module.exports = __webpack_public_path__ + "img/f_2.fec6da4a.png";